module.exports = __webpack_public_path__ + "assets/images/kundestyring-for-vinduespudsere.webp";